/**
 * Stable CSS class names for E2E — IP whitelist.
 */
export const IPWL = {
    page: 'ip-whitelist-page',
    breadcrumbSection: 'ip-whitelist-page__breadcrumb-section',
    headerToolbar: 'ip-whitelist-page__header-toolbar',
    pageTitle: 'ip-whitelist-page__page-title',
    inputButtonAddIp: 'ip-whitelist-page-input--button-add-ip',
    loadingWrap: 'ip-whitelist-page__loading-wrap',
    gridWrap: 'ip-whitelist-page__grid-wrap',

    actionsCellWrap: 'ip-whitelist-page-datagrid-actions-cell',
    inputButtonRowEdit: 'ip-whitelist-page-input--button-row-edit',
    inputButtonRowDelete: 'ip-whitelist-page-input--button-row-delete',

    drawerFormRoot: 'ip-whitelist-drawer-form',
    drawerTitle: 'ip-whitelist-drawer-form__title',
    inputTextIpAddress: 'ip-whitelist-drawer-form-input--text-ip-address',
    inputTextDescription: 'ip-whitelist-drawer-form-input--text-description',
    drawerFooter: 'ip-whitelist-drawer-form__footer',
    inputButtonCancel: 'ip-whitelist-drawer-form-input--button-cancel',
    inputButtonDrawerSave: 'ip-whitelist-drawer-form-input--button-save',
} as const;

export const iwlCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
